import React from "react";
import { FormsFolder } from "./components/form-folders/FormsFolder";
import { SpinnerFullScreen } from "../../components/SpinnerFullScreen";
import { useAppSelector } from "../../redux/store";
import { formSliceSelectors } from "../../redux/forms/form.selector";
import { Flex } from "../../components/Flex";
import styled from "styled-components";
import { Spacing } from "../../theme/Spacing";
import { AtiraEmpty } from "../../components/AtiraEmpty";
import { useTranslation } from "react-i18next";
import { userSliceSelectors } from "../../redux/user/user.selector";
import { useAtiraFormContext } from "./context/form-context";

const FoldersWrapper = styled(Flex)`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(12rem, 1fr));
  gap: ${Spacing.m};
  width: 100%;
  padding: ${Spacing.m};
  padding-top: 0;
`;

export const FoldersContent: React.FC = () => {
  const { t } = useTranslation();
  const { setFormsFolderCreateVisible } = useAtiraFormContext();

  const foldersLoading = useAppSelector(
    formSliceSelectors.selectFoldersLoading,
  );
  const folders = useAppSelector(formSliceSelectors.selectFolders);

  const reachedFoldersLimit = Boolean(folders?.length && folders.length >= 6);
  const userPermissions = useAppSelector(userSliceSelectors.selectLoggedInUser)
    ?.permissions?.permissions;

  if (foldersLoading) {
    return <SpinnerFullScreen containerHeight={"10rem"} />;
  }

  if (!folders?.length) {
    return (
      <Flex marginTop="m">
        <AtiraEmpty
          description={t("forms.folders.empty")}
          action={{
            title: t("common.create"),
            hide: userPermissions?.FORM.UPDATE !== true,
            onClick: () => setFormsFolderCreateVisible(true),
            disabled: reachedFoldersLimit,
            tooltip: reachedFoldersLimit
              ? t("forms.folders.reachedLimit", {
                  count: 6,
                })
              : undefined,
          }}
        />
      </Flex>
    );
  }

  return (
    <FoldersWrapper>
      {folders.map((folder) => (
        <FormsFolder key={folder._id} folder={folder} />
      ))}
    </FoldersWrapper>
  );
};
